import { Icon } from '@/components/Icon';

/**
 * Единая строка поиска — раньше дублировалась инлайн в 6 местах (ClientsPage,
 * StepTests/StepPrices, LibraryTestsPanel/PricesPanel, TestsCatalogPage).
 * Крестик сброса — только когда есть что сбрасывать (value непустой);
 * `loading` — тот же спиннер-колечко, что раньше рисовали инлайн в местах,
 * где поиск идёт поверх уже показанных данных (LibraryTestsPanel/PricesPanel),
 * а не полноэкранным лоадером.
 */
export function SearchBox({
  value,
  onChange,
  placeholder = 'Поиск по названию',
  loading = false,
  iconSize = 15,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  loading?: boolean;
  iconSize?: number;
}) {
  return (
    <label className="search-box">
      <Icon name="search" size={iconSize} />
      <input type="text" placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} />
      {loading && <span className="spinner__ring spinner__ring--sm" aria-hidden="true" />}
      {value && (
        <button
          type="button"
          className="search-box__clear"
          onClick={() => onChange('')}
          aria-label="Очистить поиск"
        >
          <Icon name="close" size={12} />
        </button>
      )}
    </label>
  );
}
